<template>
    <div>
        <common-table :url="url" :table-columns="tableColumns" :form-fields="formFields" :operate="operate" :permission="permission"></common-table>
        <div class="dialog">
            <!--菜单权限模态框-->
            <el-dialog :title="menuTitle" @closed="resetMenuAu"
                       :visible.sync="menuVisible" custom-class="common-dialog" :close-on-click-modal="false">
                <div class="fc_dialog_body">
                    <!--树形菜单-->
                    <el-tree :data="menuList" ref="menuTree" highlight-current default-expand-all show-checkbox node-key="id" :expand-on-click-node="false">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span>
                            <label><i class="menu_icon ml-10" :class="data.icon"></i></label>
                        </span>
                        <span class="menu_name ml-20">{{ data.menuName }}</span>
                    </span>
                    </el-tree>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="menuVisible = false">取 消</el-button>
                    <el-popconfirm :title="'确定更新？'" @onConfirm="updateRoleMenu">
                        <el-button slot="reference"  size="small" type="primary" class="ml-10">确 定</el-button>
                    </el-popconfirm>
                </div>
            </el-dialog>

            <!--权限模态框-->
            <el-dialog :title="permissionTitle" @closed="resetPermission"
                       :visible.sync="permissionVisible" custom-class="common-dialog permission-dialog" :close-on-click-modal="false">
                <div class="fc_dialog_body">
                    <div class="ml-20">
                        <el-button size="small" type="text" @click="checkAllPermission">全 选</el-button>
                        <el-button size="small" type="text" @click="clearPermission">清 空</el-button>
                    </div>
                    <!--树形菜单--><!--default-expand-all-->
                    <el-tree class="permission-tree" :data="permissionList" ref="permissionTree"
                             highlight-current show-checkbox node-key="id" :expand-on-click-node="false">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span class="permission_name ml-10">{{ data.name }}</span>
                        <!--<span class="permission_permission ml-20">{{ data.permission }}</span>-->
                    </span>
                    </el-tree>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="permissionVisible = false">取 消</el-button>
                    <el-popconfirm :title="'确定更新？'" @onConfirm="updateRolePermission">
                        <el-button slot="reference"  size="small" type="primary" class="ml-10">确 定</el-button>
                    </el-popconfirm>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "Role",
        components: {CommonTable},
        data(){
            return{
                permission:{
                    add: 'role:add',
                    update: 'role:update',
                    delete: 'role:delete',
                    deleteBatch: 'role:deleteBatch'
                },
                url: {
                    get: '/role/list',
                    add: '/role/add',
                    update: '/role/update',
                    delete: '/role/delete/',
                    delete_batch: '/role/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '75',
                },{
                    field: 'roleName',
                    label: '角色',
                    show: true,
                    width: '',
                },{
                    field: 'introduce',
                    label: '介绍',
                    show: true,
                    width: '',
                }],
                formFields: {
                    addTitle: '添加角色',
                    updateTitle: '修改角色',
                    model: [{
                        field: 'roleName',
                        label: '角色名：',
                        type: 'input',
                        placeholder: '角色名',
                        rules:[{required: true, message: '请输入角色名', trigger: 'blur'}],
                        add: true,
                        update: true,
                        onlyShow: true,
                    },{
                        field: 'introduce',
                        label: '角色介绍：',
                        type: 'input',
                        placeholder: '角色介绍',
                        rules:[{required: false}],
                        add: true,
                        update: true,
                    }]
                },
                operate:[{
                    icon: 'el-icon-menu',
                    type: 'text',
                    text: '菜单',
                    handle: (row) => {
                        this.openMenuAuth(row);
                    }
                },{
                    icon: 'el-icon-s-shop',
                    type: 'text',
                    text: '权限',
                    // eslint-disable-next-line no-unused-vars
                    handle: (row) => {
                        this.openPermission(row);
                    }
                }],

                //是否显示菜单权限模态框
                menuVisible: false,
                menuTitle: '',
                //菜单列表
                menuList: [],
                //修改菜单的角色id
                roleId: null,

                permissionVisible: false,
                permissionTitle: '',
                permissionList: [],
            }
        },

        methods: {
            //打开菜单权限模态框
            openMenuAuth(role){
                this.getAllMenu(role.id);
                this.roleId = role.id;
                this.menuTitle = role.roleName + ' 菜单权限';
                this.menuVisible = true;
            },
            //获取所有菜单
            getAllMenu(roleId){
                this.$axios.post({
                    url: '/menu/all',
                    success: (res) => {
                        if (res.code === 0){
                            this.menuList = this.$toTree.toTree(res.data);
                            this.getRoleMenuIds(roleId,res.data);//获取权限菜单
                        }
                    },
                    error: () => {
                        this.$message.error('出错了');
                    }
                });
            },
            //获取角色被赋予的权限菜单
            getRoleMenuIds(roleId,menus) {
                this.$axios.post({
                    url: '/roleMenu/menuIds/' + roleId,
                    success: (res) => {
                        if (res.code === 0){
                            const menuIds = [];
                            res.data.forEach(menuId => {
                                menus.some(menu => {
                                    if (menuId === menu.id){
                                        if (menu.path !== null && menu.path !== '' && menu.path !== undefined){
                                            menuIds.push(menuId);
                                            return true;
                                        }
                                    }
                                });
                            });
                            this.$refs.menuTree.setCheckedKeys(menuIds);//选中被赋予的菜单
                        }else {
                            this.$message.error(res.data);
                        }
                    },
                    error: () => {
                        this.$message.error('出错了');
                    }
                });
            },
            //更改角色权限菜单
            updateRoleMenu(){
                let menuIds = this.$refs.menuTree.getHalfCheckedKeys();
                menuIds = menuIds.concat(this.$refs.menuTree.getCheckedKeys());
                this.$axios.post({
                    url: '/roleMenu/update',
                    data: {roleId: this.roleId, menuIds:menuIds},
                    success: (res) => {
                        switch (res.code) {
                            case 0: {
                                this.menuVisible = false;
                                this.$message.success('权限菜单设置成功')
                                break;
                            }
                            default: {
                                this.$message.error(res.data);
                                break;
                            }
                        }
                    },
                    error: () => {
                        this.$message.error('出错了');
                    }
                });
            },
            resetMenuAu(){
                this.menuList = [];
                this.$refs.menuTree.setCheckedKeys([]);
            },

            /**
             * 打开权限模态框
             */
            openPermission(role){
                this.getAllPermission(role.id);
                this.roleId = role.id;
                this.permissionTitle = role.roleName + ' 的权限';
                this.permissionVisible = true;
            },

            /**
             * 获取所有权限
             * @param roleId
             */
            // eslint-disable-next-line no-unused-vars
            getAllPermission(roleId){
                this.$axios.get({
                    url: '/permission/all',
                    success: (res) => {
                        this.permissionList = this.$toTree.toTree(res.data);
                        this.getRolePermissionIds(roleId, res.data);//获取角色权限ids
                    },
                    error: () => {
                        this.$message.error('出错了');
                    }
                })
            },
            /**
             * 获取被赋予的权限
             * @param roleId
             * @param perms
             */
            getRolePermissionIds(roleId, perms){
                this.$axios.post({
                    url: '/rolePermission/permissionIds/' + roleId,
                    success: (res) => {
                        if (res.code === 0) {
                            if (res.data.length && res.data.length > 0) {
                                const permIds = [];
                                res.data.forEach(id => {
                                    perms.some(item => {
                                        if (item.id === id) {
                                            if (item.permission !== '' && item.permission !== null && item.permission) {
                                                permIds.push(id);
                                                return true;
                                            }
                                        }
                                    })
                                })
                                //选中被赋予的权限
                                this.$refs.permissionTree.setCheckedKeys(permIds);
                            }
                            return;
                        }
                        this.$message.error(res.data)
                    },
                    error: () => {
                        this.$message.error('出错了');
                    }
                });
            },

            /**
             * 更改角色的权限
             */
            updateRolePermission(){
                let permissionIds = this.$refs.permissionTree.getCheckedKeys();
                this.$axios.post({
                    url: '/rolePermission/update',
                    data: {roleId: this.roleId, permissionIds:permissionIds},
                    success: (res) => {
                        switch (res.code) {
                            case 0: {
                                this.permissionVisible = false;
                                this.$message.success('角色权限设置成功');
                                break;
                            }
                            default: {
                                this.$message.error(res.data);
                                break;
                            }
                        }
                    },
                    error: () => {
                        this.$message.error('出错了');
                    }
                });
            },
            /**
             * 全选
             */
            checkAllPermission(){
                this.$refs.permissionTree.setCheckedNodes(this.permissionList);
            },
            /**
             * 取消全选
             */
            clearPermission(){
                this.$refs.permissionTree.setCheckedKeys([]);
            },
            /**
             * 重置
             */
            resetPermission(){
                this.permissionList = [];
                this.clearPermission();
            },

        }

    }
</script>

<style scoped>
    .dialog >>> .common-dialog {
        max-width: 300px!important;
    }
    .permission-tree {
        max-height: 320px;
        overflow: scroll;
    }
    .permission_name {
        display: inline-block;
        min-width: 155px;
    }
    .permission_permission {
        display: inline-block;
        /*min-width: 200px;*/
    }
</style>
